import { Filter, WarningTriangle } from 'iconoir-react'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import UnreadText from '../components/common/UnreadText'
import MainLayout from '../layouts/MainLayout'
import queryString from 'query-string'
import { ASSIGNEE_TYPE } from '../utils/constants'
import EmptyData from '../components/image/EmptyData'
import SkeletonTable from '../components/Skeleton/SkeletonTable'
import CheckLight from '../components/image/CheckLight'
import CheckSuccessIcon from '../components/image/CheckSuccessIcon'
import { BiUserVoice } from 'react-icons/bi'
import moment from 'moment'
import ContentModal from '../components/dialog/ContentModal'
import HandlerModal from '../components/dialog/HandlerModal'
import SearchAdvanceDrawer from '../modules/mission/SearchAdvanceDrawer'
import { EmptyText } from '../components/common/CellText'
import { AiOutlineFieldTime } from 'react-icons/ai'
import { useTheme } from '@emotion/react'
import { Button } from '@mui/material'
import CreateModal from '../modules/mission/CreateModal'
const LANH_DAO_GIAO_VIEC_WIDTH = 180

const date = new Date()
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

const MissionPage = ({ taskStore }) => {
  const {
    getTaskList,
    taskList,
    getTaskLevelList,
    taskLevelList,
    getTagList,
    tagList,
  } = taskStore
  const [message, setMessage] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')
  const [check, setCheck] = useState(false)
  const createMessage = (message, openMessage, severity) => {
    setMessage(message)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const [openContent, setOpenContent] = useState(false)
  const [openLeader, setOpenLeader] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [taskSelect] = useState({})
  const [openCre, setOpenCre] = useState(false)
  const [taskListView, setTaskListView] = useState([])
  const theme = useTheme()

  const [filter, setFilter] = useState({
    date_by: 'DISPLAY_DATE',
    from_date: moment(firstDay).format('YYYY-MM-DD'),
    to_date: moment(lastDay).format('YYYY-MM-DD'),
    tag: null,
    tien_do: null,
    id_task_level: null,
  })

  const handelGetTaskList = async params => {
    try {
      setLoading(true)
      await getTaskList(params)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = {
      date_by: queryStringParse.date_by || filter.date_by,
      from_date: queryStringParse.from_date || filter.from_date,
      to_date: queryStringParse.to_date || filter.to_date,
      tien_do: queryStringParse.tien_do || filter.tien_do,
      id_task_level: queryStringParse.id_task_level || filter.id_task_level,
      tag: queryStringParse.tag || filter.tag,
      //     id_unit: null,
      //     id_user_unit: null,
      //     loai_nhiem_vu: null,
      //     assignee: null,
      //     date_by: "DISPLAY_DATE",
    }
    setFilter(params)
    ;(async () => {
      await Promise.all([
        getTaskLevelList(),
        handelGetTaskList(params),
        getTagList(),
      ])
      setIsRefreshPage(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (isRefreshPage) return
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    })
    navigate({ pathname: '/mission', search: queryStringStringify })
    ;(async () => {
      try {
        await handelGetTaskList(filter)
      } catch (err) {
        console.log(err)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])
  useEffect(() => {
    const newTaskList = taskList.map(item => item.content).flat()
    const groupByTaskCode = newTaskList.reduce((result, currentValue) => {
      ;(result[currentValue.task_code] =
        result[currentValue.task_code] || []).push(currentValue)
      return result
    }, {})
    const unique = [
      ...new Map(newTaskList.map(item => [item.task_code, item])).values(),
    ]
    setTaskListView(
      unique.map(item => ({
        ...item,
        leader: groupByTaskCode[item.task_code].map(sub => sub.leader_name),
        overdue:
          item.ket_qua.phan_tram_hoan_thanh !== '100' &&
          item.ngay_ket_thuc &&
          moment(new Date()).isAfter(item.ngay_ket_thuc),
      }))
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskList])

  function createData(status, noi_dung, leader, period, task_code) {
    return {
      status,
      noi_dung,
      leader,
      period,
      task_code,
    }
  }
  const formatData = dataList => {
    return dataList.map(record =>
      createData(
        <div className="flex items-center gap-4 ">
          {' '}
          <div>
            {record?.ket_qua?.phan_tram_hoan_thanh === '0' ? (
              <CheckLight />
            ) : (
              <CheckSuccessIcon />
            )}
          </div>{' '}
          <div>
            {record?.overdue && (
              <WarningTriangle
                color="#DB8300"
                fill="#FFE5A1"
                width={20}
                height={20}
              />
            )}
          </div>
        </div>,
        <div>
          {record.noi_dung ? (
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                lineHeight: '25px',
                WebkitLineClamp: '2',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                maxHeight: '50px',
                padding: '4px',
                color: theme.color.primary,
              }}>
              <div dangerouslySetInnerHTML={{ __html: record.noi_dung }}></div>
            </div>
          ) : (
            <EmptyText>Chưa có nội dung</EmptyText>
          )}
        </div>,
        <UnreadText
          text={record?.leader.join(', ')}
          width={LANH_DAO_GIAO_VIEC_WIDTH}
        />,
        <div style={{}}>
          {`${
            record.ngay_bat_dau
              ? moment(record.ngay_bat_dau).format('DD/MM/YYYY')
              : 'Không rõ'
          } 
              -
              ${
                record.ngay_ket_thuc
                  ? moment(record.ngay_ket_thuc).format('DD/MM/YYYY')
                  : 'Không rõ'
              }`}
        </div>,

        record?.task_code
      )
    )
  }
  const rows = formatData(taskListView)
  return (
    <div style={{ backgroundColor: theme.background.base, minHeight: '850px' }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <div className="font-bold text-[28px] leading-[29px]  ">Nhiệm vụ</div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenDrawer(true)
          }}>
          <Filter />
        </span>
      </div>
      <MainLayout>
        <div className="pt-20">
          <Button
            variant="contained"
            color="primary"
            style={{ margin: '10px', textTransform: 'none' }}
            onClick={() => setOpenCre(true)}>
            Thêm nhiệm vụ
          </Button>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 pl-5  ">
              <CheckSuccessIcon />
              <span className="font-bold text-[14px] leading-6 text-[#23374D]">
                Hoàn thành:{' '}
                {
                  taskListView?.filter(
                    item => item?.ket_qua?.phan_tram_hoan_thanh === '100'
                  ).length
                }
              </span>
            </div>
            <div className="flex items-center gap-2">
              {' '}
              <CheckLight />
              <span className="font-bold text-[14px] leading-6 text-[#23374D]">
                Chưa hoàn thành:{' '}
                {
                  taskListView?.filter(
                    item => item?.ket_qua?.phan_tram_hoan_thanh === '0'
                  ).length
                }
              </span>
            </div>
          </div>
          {loading ? (
            <SkeletonTable />
          ) : taskList?.length > 0 ? (
            <>
              <section className=" overflow-x-auto hideScrollbar work-table pb-[30px]">
                <>
                  {rows.map((row, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        navigate(`/mission/view/${row.task_code}`)
                      }}
                      style={{
                        backgroundColor: theme.color.text1,
                        padding: '10px',
                        borderRadius: '10px',
                        margin: '8px ',
                        boxShadow: theme.boxShadow.boxShadow2,
                      }}>
                      <div className="flex justify-between">
                        {row.status}
                        <div
                          className="flex gap-1 items-center"
                          style={{
                            minWidth: '20px',
                            height: '20px',
                            color: theme.color.time,
                          }}>
                          <AiOutlineFieldTime />
                          {row.period}
                        </div>
                      </div>
                      <div className="flex gap-1 items-center mt-2">
                        {row.noi_dung}
                      </div>
                      <div className="flex gap-1 items-center mt-2">
                        <BiUserVoice
                          style={{
                            minWidth: '20px',
                            height: '20px',
                            color: theme.color.primary,
                          }}
                        />
                        {row.leader}
                      </div>
                    </div>
                  ))}
                </>
              </section>{' '}
            </>
          ) : (
            <EmptyData />
          )}
        </div>
        <CreateModal
          createMessage={createMessage}
          queryStringParsed={queryStringParse}
          filter={filter}
          params={setFilter}
          open={openCre}
          handleClose={() => {
            setOpenCre(false)
          }}
          check={check}
          setCheck={setCheck}
        />
        <ContentModal
          open={openContent}
          handleClose={() => {
            setOpenContent(false)
          }}
          content={taskSelect?.noi_dung}
          headerTitle="Nhiệm vụ"
        />
        <HandlerModal
          open={openLeader}
          handleClose={() => {
            setOpenLeader(false)
          }}
          handler={taskSelect?.leader?.map(item => ({
            full_name: item,
            assignee_type: ASSIGNEE_TYPE.GROUP,
          }))}
          headerTitle="Lãnh đạo giao việc"
        />

        <SearchAdvanceDrawer
          open={openDrawer}
          handleOpenSearchAdvance={() => {
            setOpenDrawer(true)
          }}
          onClose={() => setOpenDrawer(false)}
          filter={filter}
          setFilter={setFilter}
          taskLevelList={taskLevelList}
          tagList={tagList}
        />
      </MainLayout>
    </div>
  )
}

export default inject('taskStore')(observer(MissionPage))
